import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import CompanyActivityRowCard from "./CompanyActivityCard";
import { onCompanyActivity } from "common/signalR";

interface Props {
  companyId: number
  config: server.dto.ActivityPanelConfig
}

const CompanyActivityPanel = (props: Props) => {
  const { companyId, config } = props;

  return <ActivityPanel<server.dto.CompanyActivity>
    config={config}
    fetchActivities={(page, perPage) => window.CoreApi.Company.ListActivity({ page, perPage, itemId: companyId })}
    renderActivity={(activity) => <CompanyActivityRowCard key={activity.activityId} activity={activity} />}
    onActivityRegisterFn={onCompanyActivity}
    onActivity={() => ({ refreshActivities: true })}
  />;
};

export default CompanyActivityPanel;